export default __webpack_public_path__ + "static/media/in-mz.ed8c7987.svg";